const state = {
  name: "",
  phone: "",
  idNumber: "",
  verification: false,
  exposure: false,
  contract: false,
  paymentMethod: 1,
  jieguo: {
    "detectionId": null,
    "content": "",
    "name": "",
    "idNumber": "",
    "phone": "",
    "exposureList": [],
    "contractList": [],
    "verificationId": null,
    "verification": null,
    "success": null,
    "createdAt": null,
    "emp": null
  },
  fengxianVisible: false,
  yitiaoguo: false
}
const mutations = {
  setName(state, payload) {
    state.name = payload
  },
  setPhone(state, payload) {
    state.phone = payload
  },
  setIdNumber(state, payload) {
    state.idNumber = payload
  },
  setVerification(state, payload) {
    state.verification = payload
  },
  setExposure(state, payload) {
    state.exposure = payload
  },
  setContract(state, payload) {
    state.contract = payload
  },
  setPaymentMethod(state, payload) {
    state.paymentMethod = payload
  },
  setjieguo(state, payload) {
    state.jieguo = payload
  },
  setFengxianVisible(state, payload) {
    state.fengxianVisible = payload
  },
  setYitiaoguo(state, payload) {
    state.yitiaoguo = payload
  },
}
const actions = {
  setName({ commit }, payload) {
    commit('setName', payload)
  },
  setPhone({ commit }, payload) {
    commit('setPhone', payload)
  },
  setIdNumber({ commit }, payload) {
    commit('setIdNumber', payload)
  },
  setVerification({ commit }, payload) {
    commit('setVerification', payload)
  },
  setExposure({ commit }, payload) {
    commit('setExposure', payload)
  },
  setContract({ commit }, payload) {
    commit('setContract', payload)
  },
  setPaymentMethod({ commit }, payload) {
    commit('setPaymentMethod', payload)
  },
  clearData({ commit }) {
    commit('setName', '')
    commit('setPhone', '')
    commit('setIdNumber', '')
    commit('setVerification', false)
    commit('setExposure', false)
    commit('setContract', false)
    commit('setPaymentMethod', 1)
  },
  setFengxianVisible({ commit }, payload) {
    commit('setFengxianVisible', payload)
  },
  setjieguo({ commit }, payload) {
    commit('setjieguo', payload)
  },
  setYitiaoguo({ commit }, payload) {
    commit('setYitiaoguo', payload)
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}